import { Field } from "formik";
import WarningIcon from "@mui/icons-material/Warning";
import { pink } from "@mui/material/colors";
import {
  VIPSDataServiceURL,
  requestOptions,
} from "../../Constants/GlobalConstant";
import { getVendorIdFromSession } from "../../CommonFuntion/TableBodyFormikHelper";
// add helper to reset a row’s current and following keys
const resetKeys = (dropDownVal, startIndex, tdkeys, tableName, schemaPageFields, setFieldValue) => {
  // Reset keys and keyValues for all dropdowns from startIndex onwards
  Object.entries(dropDownVal).forEach(([k, v]) => {
    if (Number(k) >= startIndex) {
      v.key[tdkeys] = "";
      if (v.keyValues) v.keyValues[tdkeys] = [];
    }
  });

  // Reset form fields for catalogue fields with keyIndex > startIndex - 1 and not 0
  const fieldsToReset = schemaPageFields.filter(
    (field) => field.keyIndex !== 0 && field.keyIndex > startIndex - 1
  );

  fieldsToReset.forEach((field) => {
    const fieldName = `${tableName}[${tdkeys}].${field.fieldName}`;
    setFieldValue(fieldName, "");
  });
};
const CatalogDropdownField = ({
  element,
  values,
  name,
  tableName,
  tdkeys,
  catDropDown,
  setCatDropDown,
  setFieldValue,
  loadingStates,
  error,
  setCatTabData,
  schemaPageFields,
  store_grp,
  user_id,
}) => {
  if (element.prefix === "CAT" && element.catalogueSchemaType === 3) {

    const handleCatDropChange = (e) => {
      const selectedValue = e.target.value;
      let changeDropDownVal = { ...catDropDown };
      let keyIndex = element?.keyIndex;

      changeDropDownVal[keyIndex]["key"][tdkeys] = selectedValue;

      // reset subsequent keys and keyValues for this row
     resetKeys(changeDropDownVal, keyIndex + 1, tdkeys,tableName,schemaPageFields,setFieldValue);

      // API fetching logic here...
      const vendorId = getVendorIdFromSession();
      let getCatalogueKeyValuesApiUrl =
        `${VIPSDataServiceURL}/Catalogue/GetCatalogueKeyValues?catId=${element?.catId}` +
        `&KeyNo=${keyIndex + 1}`;
      const entriesDropDown = Object.entries(changeDropDownVal);
      entriesDropDown?.forEach(([key, value]) => {
        getCatalogueKeyValuesApiUrl =
          getCatalogueKeyValuesApiUrl +
          `&key${parseInt(key)}=${value["key"]?.[tdkeys] ?? ""}`;
      });
      getCatalogueKeyValuesApiUrl += `&vendorId=${encodeURIComponent(vendorId)}`;


       var labelCatalougeFields = schemaPageFields.filter(
                      (x) => x.keyIndex ===0 //&& x.visible !== false
                    );
      if (labelCatalougeFields.length > 0) {
        labelCatalougeFields.forEach((x) => {
          const labelCatalougeFieldName = `${tableName}[${tdkeys}].${x.fieldName}`;
          setFieldValue(labelCatalougeFieldName, "");
        });
      }
      // calling api and bind child dropdown values
      if (keyIndex < entriesDropDown.length) {
        if (!selectedValue) {
          // Blank selected — clear next dropdown's options and downstream state
          changeDropDownVal[keyIndex]["keyValues"][tdkeys] = [];
          setCatDropDown({ ...changeDropDownVal });
          setCatTabData([]);
        } else {
          let catTabData = {
            value: "",
            element,
            catalogueDetailDataKey: "",
          };
          setCatTabData(catTabData);
          fetch(getCatalogueKeyValuesApiUrl, requestOptions)
            .then((response) => response.json())
            .then((data) => {
              let keyValues = [];
              if (Array.isArray(data)) {
                keyValues = data.map((x) => ({ label: x, value: x }));
              }
              changeDropDownVal[keyIndex]["keyValues"][tdkeys] = keyValues;
              setCatDropDown(changeDropDownVal);
            })
            .catch((error) => console.error("Error fetching data:", error));
        }
      } else {
        if (selectedValue) {
          const value = selectedValue;
          let getCatalogueHeaderDataApiUrl =
            `${VIPSDataServiceURL}/Catalogue/GetCatalogueHeaderData?catId=${element?.catId}` +
            `&pageID=${element?.pageId}`;
          const entriesDropDown = Object.entries(catDropDown);
          let catalogueDetailDataKey = "";
          entriesDropDown?.forEach(([key, value]) => {
            catalogueDetailDataKey =
              catalogueDetailDataKey +
              `&key${parseInt(key)}=${value["key"][tdkeys]}`;
            getCatalogueHeaderDataApiUrl =
              getCatalogueHeaderDataApiUrl +
              `&key${parseInt(key)}=${value["key"][tdkeys]}`;
          });
          getCatalogueHeaderDataApiUrl =
            getCatalogueHeaderDataApiUrl +
            `&storeGrp=${store_grp}` +
            `&userId=${user_id}`;

          fetch(getCatalogueHeaderDataApiUrl, requestOptions)
            .then((response) => response.json())
            .then((data) => {
   
                 var labelCatalogueSchemaType = schemaPageFields.filter(
                      (x) => x.keyIndex ===0 //&& x.visible !== false
                    );
              if (data.catData.length > 0) {
                const requiredData = data.catData;
                requiredData.forEach((field) => {
                  field.forEach((x) => {
                    let labelCatalogueField = labelCatalogueSchemaType.find(
                      (y) => y.catFieldId === x.ID
                    )?.fieldName;
                    if (labelCatalogueField !== undefined) {
                      const name2 = `${tableName}[${tdkeys}].${labelCatalogueField}`;
                      setFieldValue(name2, x.Value);
                    }
                  });
                });
                setFieldValue(`${tableName}[${tdkeys}].${name}`, value);
              } else {
                alert(data.errorDescription);
                var catalougeFields = schemaPageFields.filter(
                  (y) => y.schemaType === 24
                );
                if (catalougeFields.length > 0) {
                  catalougeFields.forEach((x) => {
                    const name2 = `${tableName}[${tdkeys}].${x.fieldName}`;
                    setFieldValue(name2, "");
                  });
                }
              }
            })
            .catch((error) => console.error("Error fetching data:", error));
          let catTabData = {
            value,
            element,
            catalogueDetailDataKey,
          };
          setCatTabData(catTabData);
        } else {
          setCatTabData([]);
        }
      }
      setFieldValue(`${tableName}[${tdkeys}].${name}`, selectedValue);
    };

    return (
      <div className="wrapper">
        <div className="form-field">
          {loadingStates[tdkeys] ? (
            <div className="loading-indicator">Loading...</div>
          ) : (
            <Field
              as="select"
              className="tableInput"
              id={`select-${tdkeys}`}
              name={`${tableName}[${tdkeys}].${name}`}
              value={values?.[tableName]?.[tdkeys]?.[name] || ""}
              onChange={handleCatDropChange}
              data-testid="CatalogDropdownField"
            >
              <option value=""></option>
              {(
                catDropDown?.[element?.catFieldId]?.keyValues?.[tdkeys] || []
              ).map((i, index) => (
                <option key={index} value={i.label}>
                  {i.label}
                </option>
              ))}
            </Field>
          )}
          {error?.[name] && (
            <span className="icon">
              <WarningIcon sx={{ color: pink[500] }} />
            </span>
          )}
        </div>
      </div>
    );
  }
  return null;
};

export default CatalogDropdownField;
